import React from 'react'
import { Box, Typography, Button, Paper } from '@material-ui/core'
import { useUpgradeFlow } from 'lib/hooks/use-upgrade-flow'
import UpgradeSuccessModal from 'components/upgrade-success-modal'

const UpgradeModal = ({
  pageName,
  title,
  description,
  buttonText = 'Upgrade Now',
  showBlurOverlay = true,
  children,
}) => {
  const {
    hasPaidTier,
    showSuccessModal,
    upgradeLoading,
    handleUpgradeClick,
    handleDismiss,
  } = useUpgradeFlow(pageName)

  return (
    <>
      {children}

      {/* Blur overlay for non-paid tier users */}
      {!hasPaidTier && showBlurOverlay && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            elevation={8}
            style={{
              padding: '32px',
              textAlign: 'center',
              maxWidth: '500px',
              margin: '16px',
            }}
          >
            <Typography variant="h5" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body1" style={{ marginBottom: '24px' }}>
              {description}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleUpgradeClick}
              style={{ cursor: 'pointer' }}
            >
              {upgradeLoading ? 'Loading...' : buttonText}
            </Button>
          </Paper>
        </Box>
      )}

      {/* Always render success modal, regardless of paid tier status */}
      <UpgradeSuccessModal isOpen={showSuccessModal} onClose={handleDismiss} />
    </>
  )
}

export default UpgradeModal
